import envelopeTurquoise from '../../../assets/icons/envelope-turquoise.svg'
import envelopeOrange from '../../../assets/icons/envelope-orange.svg'

export const notificationTypes = {
  COMMON: {
    avatar: envelopeTurquoise,
    color: '#028BB7',
    backgroundColor: '#D8EEF6',
    type: 'Comunicado geral'
  },
  OFFICIAL: {
    avatar: envelopeOrange,
    color: '#E65B00',
    backgroundColor: '#FFD7C9',
    type: 'Comunicado oficial'
  }
}

export const INITIAL_SKIP = 0
export const INITIAL_PAGE = 1
export const SKIP = 0
export const LIMIT = 8
